import React from "react";
import CircularProgress from '@material-ui/core/CircularProgress';

import "./loading.css";

const loading = () => (
  <div style={{display:'flex',height:'100%',alignItems:'center',justifyContent:'center'}}>
    <CircularProgress  />
  </div>
);

export default loading;